import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';

const BLOCKED_INVOICE_PATHS = ['/invoice/view', '/invoice/create', '/invoice/patient-list'];

@Injectable({
  providedIn: 'root'
})
export class InvoiceBlockGuard implements CanActivate {
  constructor(private router: Router) {}

  canActivate(_route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const url = state.url.split('?')[0];
    if (BLOCKED_INVOICE_PATHS.some(p => url.startsWith(p))) {
      this.router.navigate(['/invoice/review']);
      return false;
    }
    return true;
  }
}
